import { Link } from "react-router-dom";
import Logo from "./Logo";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-white/10 bg-black">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 py-16 md:py-24">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-12">
          <div>
            <div className="flex items-center gap-4 mb-6">
              <Logo size={34} />
              <span className="font-display text-2xl tracking-[0.25em] text-white">TGPHOTOSHOP</span>
            </div>
            <p className="text-sm text-zinc-500 max-w-sm leading-relaxed">
              Fine art photography, captured slowly and printed rarely. Every frame
              available as a licensed high-resolution digital download.
            </p>
          </div>
          <div className="flex gap-16">
            <div className="flex flex-col gap-3">
              <span className="text-xs tracking-[0.2em] uppercase text-zinc-600 font-medium">Explore</span>
              <Link to="/" className="text-sm text-zinc-400 hover:text-white transition-colors duration-300" data-testid="footer-home">Home</Link>
              <Link to="/gallery" className="text-sm text-zinc-400 hover:text-white transition-colors duration-300" data-testid="footer-gallery">Gallery</Link>
            </div>
            <div className="flex flex-col gap-3">
              <span className="text-xs tracking-[0.2em] uppercase text-zinc-600 font-medium">Studio</span>
              <Link to="/admin" className="text-sm text-zinc-400 hover:text-white transition-colors duration-300" data-testid="footer-studio">Studio Login</Link>
              <a href="/#about" className="text-sm text-zinc-400 hover:text-white transition-colors duration-300" data-testid="footer-about">About</a>
            </div>
          </div>
        </div>
        <div className="mt-16 pt-8 border-t border-white/5 flex flex-col sm:flex-row justify-between gap-4">
          <span className="text-xs text-zinc-600 tracking-wide">© {new Date().getFullYear()} TGPHOTOSHOP. All rights reserved.</span>
          <span className="text-xs text-zinc-600 tracking-[0.2em] uppercase">Light, held forever</span>
        </div>
      </div>
    </footer>
  );
}
